import React, { useCallback } from 'react';
import { useLocation } from '@react-router';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useGuestGuideTelemetry } from '../GuestGuideTelemetry';
import { useGetEventCTAButtonsDataLazyQuery } from '../../CtaButtons/CtaButtons.graphql.generated';
import { useTranslation } from '@shared/core';
import { GuestGuideActionButton } from '../GuestGuideActionButton';
import { Gift } from '@withjoy/joykit/icons';
import { useCarbonIframeLinkProps } from '@shared/hooks/useCarbonIframeLinkProps';

export const BrowseCouplesRegistryAction: React.FC = () => {
  const { eventHandle, eventInfo } = useEventInfo();
  const location = useLocation();
  const telemetry = useGuestGuideTelemetry();
  const { tq } = useTranslation('guestGuide');
  const [getCtaData, { data: sessionData, called: calledCTA, loading: loadingCTA }] = useGetEventCTAButtonsDataLazyQuery({
    batchMode: 'fast',
    ssr: false,
  });

  React.useEffect(() => {
    if (eventHandle) {
      getCtaData({
        variables: { name: eventHandle },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventHandle]);

  const { registryPage } = sessionData?.eventByName || {};

  const handleClick = useCallback(() => {
    telemetry.clickBrowseRegistry();
  }, [telemetry]);
  const carbonIframeLinkProps = useCarbonIframeLinkProps();

  if (loadingCTA || !calledCTA || !eventInfo || registryPage?.disabled === true) {
    return null;
  }

  return (
    <GuestGuideActionButton
      icon={<Gift size={32} />}
      as="a"
      href={`/${eventHandle}/registry${location.search}`}
      onClick={handleClick}
      {...carbonIframeLinkProps}
    >
      {tq`Browse Registry`}
    </GuestGuideActionButton>
  );
};
